import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUser } from '../selectors/auth';

/**
 * Protects routes by requiring a valid logged-in user from Redux (single source of truth).
 * After Phase 0, 401/expiry clear both localStorage and Redux, so Redux alone is sufficient.
 */
export const PrivateRoute = ({ component: Component, restrictedToLoggedInStatus, ...rest }) => {
    const user = useSelector(selectUser);

    return (
        <Route
            {...rest}
            render={(props) => {
                const userObj = user ?? null;
                const isValidUser =
                    userObj != null &&
                    typeof userObj === 'object' &&
                    !Array.isArray(userObj) &&
                    Object.keys(userObj).length > 0;

                if (!isValidUser) {
                    return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />;
                }

                if (restrictedToLoggedInStatus && userObj?.data?.LoggedInStatus !== 'Y') {
                    return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />;
                }

                return <Component {...props} />;
            }}
        />
    );
};
